import ActionButton from 'components/ActionButton';
import React, { useState } from 'react';
import { isValidPhoneNumber, showError, showSuccess } from 'utils';
import styles from './index.module.scss';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers';
import { Error } from 'components/message/Error';
import { createUser } from 'services/api/users';

const validationSchema = yup.object().shape({
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  email: yup.string().required().email(),
  phone: yup.string().required('Phone number is a required field').test('isValidPhoneNumber', 'Please enter a valid phone number', value => {
    const sanitizedPhone = isValidPhoneNumber(value);
    return sanitizedPhone?.length === 10;
  }),
  password: yup.string(),
});

type FormData = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  password: string;
};

const CreateUser = props => {
  const [loading, setLoading] = useState<boolean>(false);
  const { register, handleSubmit, errors } = useForm<FormData>({ resolver: yupResolver(validationSchema) });
  
  const createUserFn = handleSubmit(async ({
    firstName, lastName, email, phone, password,
  }) => {
    setLoading(true);
    try {
      const { user } = await createUser({ email: email?.toLowerCase(), password, phone: isValidPhoneNumber(phone), firstName, lastName });
      showSuccess('User created successfully.');
      props.history.replace(`/users/${user.objectId}`);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  });
  
  return (
    <div className={styles['main-container']}>
      <div className={styles['header']}>
        <div className={styles['heading']}>Create a New User</div>
      </div>
      <div className={styles['user-details']}>
        <div className={'d-flex'}>
          <div className={styles['name']}>
            <div className={styles['label']}>First Name</div>
            <input
              name={'firstName'}
              ref={register}
              className={'form-control'}
              disabled={loading}
            />
            {errors.firstName && <Error message={errors.firstName.message} />}
          </div>
          <div className={styles['name']}>
            <div className={styles['label']}>Last Name</div>
            <input
              name={'lastName'}
              ref={register}
              className={'form-control'}
              disabled={loading}
            />
            {errors.lastName && <Error message={errors.lastName.message} />}
          </div>
        </div>
        <div className={styles['email']}>
          <div className={styles['label']}>Email</div>
          <input
            name={'email'}
            ref={register}
            className={'form-control'}
            disabled={loading}
          />
          {errors.email && <Error message={errors.email.message} />}
        </div>
        <div className={styles['phone']}>
          <div className={styles['label']}>Phone</div>
          <input
            name={'phone'}
            ref={register}
            className={'form-control'}
            disabled={loading}
          />
          {errors.phone && <Error message={errors.phone.message} />}
        </div>
        <div className={styles['password']}>
          <div className={styles['label']}>Password</div>
          <input
            name={'password'}
            ref={register}
            className={'form-control'}
            disabled={loading}
          />
          {errors.password && <Error message={errors.password.message} />}
        </div>
      </div>
      <div className={styles['footer']}>
        <ActionButton
          text={'Cancel'}
          active={!loading}
          isLoading={false}
          onClick={() => props.history.goBack()}
          customClass={styles['cancel']}
        />
        <ActionButton
          text={'Create User'}
          active={!loading}
          isLoading={loading}
          onClick={createUserFn}
        />
      </div>
    </div>
  );
};

export { CreateUser };
